import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldAlert } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 bg-brand-navy relative overflow-hidden" data-id="element-132">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-gold/5 to-transparent pointer-events-none" data-id="element-133" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-134">
        <FadeIn data-id="element-135">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-gold/10 text-brand-gold mb-8" data-id="element-136">
            <ShieldAlert className="w-8 h-8" data-id="element-137" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-138">
            El Secreto:{' '}
            <span className="text-brand-gold" data-id="element-139">
              El Interruptor de Reactividad
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-140">
          <p className="text-xl md:text-2xl text-brand-gray/90 leading-relaxed mb-8 font-light" data-id="element-141">
            Este no es un libro de psicología abstracta. Es un manual de
            operaciones basado en la neurociencia aplicada.
          </p>
          <div className="bg-brand-slate/50 border border-brand-charcoal p-8 md:p-10 rounded-2xl text-left" data-id="element-142">
            <p className="text-lg text-brand-cream mb-4" data-id="element-143">
              Aprenderás a instalar una{' '}
              <strong className="text-brand-gold font-bold" data-id="element-144">
                "pausa técnica"
              </strong>{' '}
              entre su provocación y tu habla que desactiva su necesidad
              biológica de pelear.
            </p>
            <p className="text-lg text-brand-gray" data-id="element-145">
              Cuando tú dejas de ser predecible, él se queda sin guion para la
              batalla. El silencio estratégico, usado correctamente, es más
              ensordecedor y poderoso que cualquier grito.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}